window.addEventListener('DOMContentLoaded', ()=>{
    const queryString = window.location.search
    const params = new URLSearchParams(queryString)
    const searchType = params.get('type')
    const searchTerm = params.get('q')
    let preTag = ""
    const searchFrom = document.querySelector('form#main-search')
    if(searchFrom){
        if(searchType == 'product'){
            const productInput = document.createElement('input')
            productInput.setAttribute('type', 'hidden')
            productInput.setAttribute('name', 'type')
            productInput.setAttribute('value','product')
            searchFrom.appendChild(productInput)
        }else if(searchType == 'article'){
            const articleInput = document.createElement('input')
            articleInput.setAttribute('type', 'hidden')
            articleInput.setAttribute('name','type')
            articleInput.setAttribute('value','article')
            searchFrom.appendChild(articleInput)
            if(searchTerm.includes('tag:recipes ')){
                preTag = "tag:recipes "
            }
            if(searchTerm.includes('tag:event ')){
                preTag = "tag:event "
            }
        }
        const mainInput = searchFrom.querySelector('#Search-In-Template')
        const fakeInput = searchFrom.querySelector('#fake-input')

        searchFrom.addEventListener('submit', ()=>{
            mainInput.value = preTag + fakeInput.value
        })
    }

    //recipe search
    const recipeSearchFrom = document.querySelector('form#search-for-recipe')
    if(recipeSearchFrom){
        const input = recipeSearchFrom.querySelector('#Search-In-Template')
        const fakeInput = recipeSearchFrom.querySelector('#fake-input')
        if(input && fakeInput){
            recipeSearchFrom.addEventListener('submit', ()=>{
                input.value = "tag:recipes " + fakeInput.value
            })
        }
    }
    //event search
    const eventSearchFrom = document.querySelector('form#search-for-event')
    if(eventSearchFrom){
        const input = eventSearchFrom.querySelector('#Search-In-Template')
        const fakeInput = eventSearchFrom.querySelector('#fake-input')
        if(input && fakeInput){
            eventSearchFrom.addEventListener('submit', ()=>{
                input.value = "tag:event " + fakeInput.value
            })
        }
    }
})